import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import SSOLoginPage from "./pages/SSOLoginPage";
import SSOPassPage from "./pages/SSOPassPage";
import "antd/dist/antd.min.css";
import AdminPage from "./pages/AdminPage";
import ProjectsPage from "./pages/AdminPage/ProjectsPage";
import RolesPage from "./pages/AdminPage/RolesPage";
import UsersPage from "./pages/AdminPage/UsersPage";
import UserPage from "./pages/UserPage";
import WhiteListPage from "./pages/AdminPage/WhiteListPage";
import TagPage from "./pages/AdminPage/TagPage";
import { message } from "antd";
import { useEffect } from "react";
import { observer } from "mobx-react";
import AuthStore from "./stores/AuthStore";
import CardList from "./pages/UserPage/CardList";
import ScrollList from "./pages/UserPage/ScrollList";
import SSOGetInfoPage from "./pages/SSOGetInfoPage";
import IndexList from "./pages/UserPage/IndexList";
import _403Page from "./pages/_403Page";
import ContainerLoginPage from "./pages/ContainerLoginPage";
message.config({ maxCount: 1 });

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* <Route path="/1" element={<IndexList />} /> */}
          <Route path="/ding-container/login" element={<ContainerLoginPage />} />
          <Route path="/sso/pass" element={<SSOPassPage />} />
          <Route path="/client/userInfo/getUserInfo" element={<SSOGetInfoPage />} />
          <Route path="/sso/login" element={<SSOLoginPage />} />
          <Route path="/admin" element={<AdminPage />}>
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="roles" element={<RolesPage />} />
            <Route path="whiteList" element={<WhiteListPage />} />
            <Route path="tag" element={<TagPage />} />
            <Route path="*" element={<Navigate to="projects" replace />} />
          </Route>
          <Route path="/user" element={<UserPage />}>
            <Route path="cards" element={<CardList />} />
            <Route path="list/:projectId/:appId" element={<ScrollList />} />
            <Route path="*" element={<Navigate to="/user/cards" replace />} />
          </Route>
          <Route path="/403/:type" element={<_403Page />} />
          <Route path="*" element={<Navigate to="/user/cards" replace />} />
          <Route path="/" element={<Navigate to="/user/cards" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default observer(App);
